import {useMappedState} from 'redux-react-hook'
import {convertList, sortList, convertType} from 'utils/convertData'
import {formatNumber} from 'utils/format'
import useSymbolInfo from 'hooks/useSymbolInfo'

function useTransactionHistory () {
  const mapState = state => ({
    data: state?.orders?.transactionHistories || {},
    hasMore: state?.orders?.transactionHistoriesHasMore
  })
  const {hasMore, data: transactionHistoryEntity} = useMappedState(mapState)
  const transactionHistories = Object.values(transactionHistoryEntity)
  const {symbolInfo} = useSymbolInfo()
  const {lng} = symbolInfo

  return {
    hasMore,
    data: sortList(convertList(Object.values(transactionHistories), 'time'))?.map(v => ({
      ...v,
      balancetype: convertType(lng, v.balancetype),
      balanceDelta: formatNumber(v.balanceDelta)
    }))
  }
}

export default useTransactionHistory
